import { motion } from "framer-motion";
import { WHY_ITEMS } from "../../constants/data";
import { SectionHeading, Reveal } from "../Reveal";

const SPANS = [
  "md:col-span-4",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-4",
];

export const WhyChoose = () => (
  <section id="why" data-testid="why-choose-section" className="py-24 lg:py-32 bg-brand-navy">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="max-w-2xl">
        <SectionHeading dark title="Your Care Matters" />
        <Reveal delay={0.15}>
          <p className="mt-6 text-lg leading-relaxed text-slate-300">
            Families choose BMS for dependable support, carefully matched caregivers, and a genuine commitment to quality of life. These are the values behind every visit, every care plan, and every relationship we build.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-6 gap-5">
        {WHY_ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -4 }}
            data-testid={`why-card-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={`${SPANS[i]} rounded-2xl p-8 ${
              item.featured
                ? "bg-brand-teal text-white"
                : "bg-white/[0.06] border border-white/10 text-white hover:bg-white/[0.1]"
            } transition-colors duration-300`}
          >
            <div className={`inline-flex h-12 w-12 items-center justify-center rounded-full ${item.featured ? "bg-white/15 text-white" : "bg-brand-cyan/15 text-brand-cyan"}`}>
              <item.icon className="h-5 w-5" strokeWidth={1.5} />
            </div>
            <h3 className="mt-5 font-display text-xl md:text-2xl leading-snug">{item.title}</h3>
            <p className={`mt-3 text-base md:text-lg leading-relaxed ${item.featured ? "text-teal-50" : "text-slate-300"}`}>
              {item.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
